export default {
    location: "คลังสินค้า",
    marking: "เครื่องหมายบรรจุภัณฑ์",
    markingList: 'รายการเครื่องหมายบรรจุภัณฑ์',
    markings: 'เครื่องหมายบรรจุภัณฑ์',
    customerMarkings: 'เครื่องหมายบรรจุภัณฑ์ลูกค้า',

    supplierName: 'ชื่อผู้จัดส่ง',
    supplierContact: 'ผู้ติดต่อผู้จัดส่ง',
    purchaseOrderNo: 'หมายเลขใบสั่งซื้อ',
    supplierPurchaseNo: "หมายเลขใบสั่งซื้อของผู้จัดส่ง",
    courierNo: "หมายเลขขนส่ง",
    handleQty: 'ปริมาณ',
    pcsCtn: 'จำนวน / ชิ้น',
    packUnit: 'การบรรจุ',
    cbm: 'ลูกบาศก์',
    tValue: 'มูลค่ารวม',
    tCbm: 'ปริมาตรรวม',
    tWeight: 'น้ำหนักรวม',
    code: 'รหัส',

    loaded: 'ขึ้นตู้แล้ว',
    pending: 'ยังไม่ได้ขึ้นตู้',

    action: `ตัวเลือก`,

    systemId: 'รหัสระบบ',
    split: 'สินค้าแบ่งล็อต',
    splitId: `รหัสการแบ่งล็อต`,
    yes: 'ใช่',
    no: 'ไม่ใช่',
    isSplit: `แบ่งล็อต`,
    notSplit: `สินค้าเดิม`,

    delete: "ลบ"
}